package com.example.positionahead.domain

data class PositionSizerResult(
    val dollarAmount: Double,
    val shares: Double,
    val pricePerShare: Double,
)

object PositionSizerCalculator {

    fun calculate(
        totalToInvest: Double,
        positionPercent: Double,
        pricePerShare: Double,
    ): PositionSizerResult? {
        if (totalToInvest <= 0 || positionPercent <= 0 || positionPercent > 100 || pricePerShare <= 0) {
            return null
        }
        val dollarAmount = totalToInvest * (positionPercent / 100.0)
        val shares = dollarAmount / pricePerShare
        return PositionSizerResult(
            dollarAmount = dollarAmount,
            shares = shares,
            pricePerShare = pricePerShare,
        )
    }
}
